/**************************************************************************************************/
/*   File: /src/app/stores/selectors/authorization/selectors.ts                                   */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../../reducers/authorization/reducer';
import * as fromStates from '../../states/authorization';

/**
 * Get the authorization State
 */
export const getAuthorizationState = createFeatureSelector<fromStates.AuthorizationState>('authorization');
/**
 * Get is loading
 */
export const getIsLoading = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getIsLoading
);
/**
 * Get is authorizing
 */
export const getIsAuthorizing = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getIsAuthorizing
);
/**
 * Get is authorized
 */
export const getIsAuthorized = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getIsAuthorized
);
/**
 * Get is revoked
 */
export const getIsRevoked = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getIsRevoked
);
/**
 * Get is rejected
 */
export const getIsRejected = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getIsRejected
);
/**
 * Get Files
 */
export const getFiles = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getFiles
);
/**
 * Get upload finished
 */
export const getUploadFinished = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getUploadFinished
);
/**
 * Get messages
 */
export const getMessages = createSelector(
  getAuthorizationState,
  fromReducers.helpers.getMessages
);